var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding":"100px 0","width":"100%","text-align":"center","font-size":"4vw"}},[_c('p',[_vm._v(_vm._s(_vm.url))]),_c('p',[_vm._v("请复制链接到【电脑端浏览器】访问")])])}
var staticRenderFns = []

export { render, staticRenderFns }